import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Session from 'supertokens-web-js/recipe/session';

import { invitationsApi } from 'src/Services/API';

export const useFetchMyPendingInvitations = () => {
  const [doesSessionExist, setDoesSessionExist] = useState(false);

  useEffect(() => {
    async function checkSession() {
      if (await Session.doesSessionExist()) {
        setDoesSessionExist(true);
      } else {
        setDoesSessionExist(false);
      }
    }
    checkSession();
  }, []);

  return useQuery({
    queryKey: ['fetch-my-pending-invitations'],
    queryFn: async () => {
      return (await invitationsApi.invitationsControllerFindMyPendingInvitations()).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: doesSessionExist,
  });
};
